import React from "react";
import ShapeBG from "../../../../../media/bg/patterns/top-green.png";
import { WarningStudyPeriode } from "./WarningStudyPeriode";
import { CPDPProgress } from "../../CPDPPoints";

export function Academic({ data }) {
  const academic = data;
  
  return (
    <div id="widget-academic">
      <div className="card card-custom bg-gray-100 gutter-b   ">
        <div
          className="card-header rounded bgi-no-repeat bgi-size-cover bgi-position-y-top bgi-position-x-center align-items-start h-250px"
          style={{ backgroundImage: "url(" + ShapeBG + ")" }}
        >
          <h3 className="card-title align-items-start flex-column text-white pt-15">
            <span className="font-weight-bold font-size-h1 mb-3">
              Hello, {academic?.firstname || "-"}
            </span>
            <span className="d-block text-white ">Academic Overview</span>
            <span className="font-weight-bolder">
              {academic?.atp_term?.name || "-"}
            </span>
          </h3>
        </div>
        <div className="card-body mt-n20 px-0 pb-0">
          <div className="card-spacer mt-n20">
            <div className="row mb-7">
              <div className="col-sm-6 col-lg-6 col-xxl-6">
                <div className="bg-light-primary px-6 py-8 rounded-xl mb-3">
                  <span className="font-weight-boldest font-size-h1 d-block my-2">
                    {academic?.cgpa || "-"}
                  </span>
                  <span className="text-dark-50 font-weight-bold font-size-h1">
                    CGPA
                  </span>
                </div>
              </div>
              <div className="col-sm-6 col-lg-6 col-xxl-6">
                <div className="bg-light-primary px-6 py-8 rounded-xl">
                  <span className="font-weight-boldest font-size-h1 d-block my-2">
                    {academic?.ccredit_pass || 0}
                  </span>
                  <span className="text-dark-50 font-weight-bold font-size-h7 mt-2">
                    Cumulative Earned Credits
                  </span>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-sm-6 col-lg-6 col-xxl-6">
                <div className="bg-light-primary px-6 py-8 rounded-xl mb-3">
                  <span className="font-weight-boldest font-size-h1 d-block my-2">
                    {academic?.semester || "-"}
                    {academic.program &&
                      ((academic.program.id === 1 && academic.semester >= 13) ||
                        (academic.program.id === 2 &&
                          academic.semester >= 7)) && (
                        <sup className="text-danger">*</sup>
                      )}
                  </span>
                  <span className="text-dark-50 font-weight-bold font-size-h6 mt-2">
                    Semester
                  </span>
                </div>
              </div>
              <div className="col-sm-6 col-lg-6 col-xxl-6">
                <div className="bg-light-primary px-6 py-8 rounded-xl">
                  <span
                    className={`font-weight-boldest d-block text-capitalize ${
                      academic.status &&
                      academic.status.name &&
                      academic.status.name >= 8
                        ? "font-size-h5 my-4"
                        : "font-size-h1 my-2"
                    }`}
                  >
                    {academic?.status?.name}
                  </span>
                  <span className="text-dark-50 font-weight-bold font-size-h6 mt-2">
                    Status
                  </span>
                </div>
              </div>
            </div>

            {academic.cpdp_point ? (
              <div className="row mb-5">
                <div className={`col-12 col-sm-12`}>
                  <div className={`bg-light-${academic.cpdp_point >= 100 ? 'primary':'danger'} px-6 py-8 rounded-xl`}>
                    <CPDPProgress value={academic.cpdp_point} max={100} studentid={academic?.studentid} />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <WarningStudyPeriode student={academic} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Academic;
